import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';
import { Box, useTheme, useMediaQuery } from '@mui/material';
import Sidebar from './Sidebar';
import Footer from './Footer';
import MobileBottomNav from './MobileBottomNav';
import { useState, useRef } from 'react';

export default function Layout() {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
  const [sidebarWidth, setSidebarWidth] = useState(240);
  const [navCollapsed, setNavCollapsed] = useState(false);
  const lastScrollTop = useRef(0);

  const handleSidebarWidthChange = (width: number) => {
    setSidebarWidth(width);
  };

  const handleMainScroll = (e: React.UIEvent<HTMLDivElement>) => {
    const current = e.currentTarget.scrollTop;
    const delta = current - lastScrollTop.current;
    if (delta > 8 && current > 60) {
      setNavCollapsed(true);
    } else if (delta < -8) {
      setNavCollapsed(false);
    }
    lastScrollTop.current = current;
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        width: '100%',
        overflow: 'hidden',
      }}
    >
      <Navbar />
      <Box
        sx={{
          display: 'flex',
          flex: 1,
          width: '100%',
          overflow: 'hidden',
          position: 'relative',
          mt: { xs: '48px', sm: '64px' },
        }}
      >
        {isDesktop && <Sidebar onWidthChange={handleSidebarWidthChange} />}
        <Box
          component="main"
          onScroll={!isDesktop ? handleMainScroll : undefined}
          sx={{
            flexGrow: 1,
            p: { xs: 1, sm: 3 },
            pb: { xs: 11, sm: 3 },
            width: { xs: '100%', sm: `calc(100% - ${isDesktop ? sidebarWidth : 0}px)` },
            ml: { sm: isDesktop ? `${sidebarWidth}px` : 0 },
            transition: theme.transitions.create(['margin', 'width'], {
              easing: theme.transitions.easing.sharp,
              duration: theme.transitions.duration.leavingScreen,
            }),
            overflow: 'auto',
            height: 'calc(100vh - 48px)',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Box sx={{ flex: 1 }}>
            <Outlet />
          </Box>
          <Footer />
        </Box>
      </Box>
      {!isDesktop && <MobileBottomNav collapsed={navCollapsed} />}
    </Box>
  );
} 